import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
	providedIn: 'root'
})
export class AppService {

	constructor(private _snackBar: MatSnackBar) { }

	showMessage(message: string, duration = 3000, action?: string) {
		return this._snackBar.open(message, action, {
			duration: duration,
			horizontalPosition: 'center',
			verticalPosition: 'top',
		});
	}

	longMessage(message: string, action?: string) {
		return this.showMessage(message, 5000, action);
	}

	showError(error: Error | HttpErrorResponse) {
		console.error(error);
		let message = 'An error occured';
		if ((<HttpErrorResponse>error).error) {
			if ((<HttpErrorResponse>error).error.status_message) {
				message = (<HttpErrorResponse>error).error.status_message;
			}
			else {
				message = (<HttpErrorResponse>error).error.message;
			}
		}
		else if (error.message) {
			message = error.message;
		}
		else if (typeof error === 'string') {
			message = error as unknown as string;
		}
		this.longMessage(message);
	}
}
